import React, {PropTypes} from 'react';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const CaptainPaymentEntryListItem = ({
  virtualEventId,
  eventName,
  amountApplied,
  onVirtualEventLinkClick
}) => (
  <div className="list-group-item-labeled">
    <div className="list-group-item-labeled-child has-link"
      style={{width: 235}}
      onClick={() => onVirtualEventLinkClick(virtualEventId)}>
      <span>{'Virtual Event'}</span>
      <span>{eventName || '-'}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 125}}>
      <span>{'Amount Applied'}</span>
      <span>{`$${amountApplied.formatCurrency(2)}`}</span>
    </div>
  </div>
);

CaptainPaymentEntryListItem.propTypes = {
  virtualEventId: PropTypes.string,
  eventName: PropTypes.string,
  amountApplied: PropTypes.number,
  onVirtualEventLinkClick: PropTypes.func
};

CaptainPaymentEntryListItem.defaultProps = {
  virtualEventId: '',
  eventName: '',
  amountApplied: 0
};

export default CaptainPaymentEntryListItem;



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/CaptainPaymentVirtualEventListItem.jsx